export default __webpack_public_path__ + "static/media/RobotoCondensed-LightItalic.316b8448.ttf";